export default __webpack_public_path__ + "static/b-user-testing-screen-2-3caf094db301f99f4d5b887bc45edacc.jpg";